// import { ref, type Ref } from 'vue';

// // 1. CRIAR UM SÍMBOLO ÚNICO PARA MARCAR NOSSOS AUTOREFS
// // Usamos 'export' para que possamos importá-lo se precisarmos de verificações externas.
// export const isAutoRefSymbol = Symbol('isAutoRef');

// // 2. ATUALIZAR A ASSINATURA DE TIPO PARA INCLUIR A MARCA
// export function autoRef<T>(initial: T | null = null): Ref<T> & T & { [isAutoRefSymbol]: true } {
// 	const raw = ref<T | null>(initial);

// 	const proxy = new Proxy(raw, {
// 		get(target, prop, receiver) {
// 			// 3. ADICIONAR UM CHECK PARA O NOSSO SÍMBOLO DE MARCA
// 			// Isso identifica o proxy como um autoRef.
// 			// if (Object.getOwnPropertySymbols(proxy).length > 0) {
// 			// 	return true;
// 			// }
// 			if (prop === isAutoRefSymbol) {
// 				return true;
// 			}

// 			if (prop === 'value') {
// 				return target.value;
// 			}

// 			const value = target.value as any;
// 			if (value && typeof value === 'object' && prop in value) {
// 				const propVal = value[prop];

// 				// 4. A NOVA LÓGICA DE "DESEMBRULHAR"
// 				// Se a propriedade aninhada for um autoRef, retorne seu valor interno.
// 				if (propVal && propVal[isAutoRefSymbol]) {
// 					console.log("Desembrulhando autoRef para propriedade:", String(prop));
// 					return propVal.value;
// 				}

// 				// Se for uma função, binda o 'this'. Se for qualquer outra coisa (incluindo um ref padrão),
// 				// retorna como está.
// 				return typeof propVal === 'function' ? propVal.bind(value) : propVal;
// 			}

// 			return Reflect.get(target, prop, receiver);
// 		},
// 		set(target, prop, val, receiver) {
// 			if (prop === isAutoRefSymbol) {
// 				// Impede a modificação da nossa marca
// 				return false;
// 			}

// 			if (prop === 'value') {
// 				target.value = val as T;
// 				return true;
// 			}

// 			const value = target.value as any;
// 			if (value && typeof value === 'object') {
// 				// 5. NOVA LÓGICA DE ATRIBUIÇÃO
// 				// Se a propriedade existente for um autoRef, atribui ao seu .value
// 				const currentProp = value[prop];
// 				if (currentProp && currentProp[isAutoRefSymbol]) {
// 					currentProp.value = val;
// 					return true;
// 				}

// 				// Caso contrário, comportamento padrão
// 				value[prop] = val;
// 				return true;
// 			}

// 			return Reflect.set(target, prop, val, receiver);
// 		}
// 		// O tipo final precisa ser convertido porque o TypeScript não entende a mágica do Proxy



// 	}) as unknown as Ref<T> & T & { [isAutoRefSymbol]: true };
// 	Object.defineProperty(proxy, isAutoRefSymbol, {
// 		value: true,
// 		writable: false,     // A propriedade não pode ser alterada
// 		configurable: false, // A propriedade não pode ser deletada
// 		enumerable: false,   // A propriedade não aparecerá em laços como for...in ou Object.keys
// 	});
// 	return proxy
// }






import { ref, type Ref } from 'vue';

export function autoRef<T>(initial: T | null = null): Ref<T> & T {
	const raw = ref<T | null>(initial);

	return new Proxy(raw, {
		get(target, prop, receiver) {
			if (prop === 'value') {
				// Retornar o valor original, não um proxy
				const value = target.value;
				return value && typeof value === 'object' && (value as any).__v_raw
					? (value as any).__v_raw
					: value;
			}

			const value = target.value as any;
			if (value && typeof value === 'object' && prop in value) {
				// Se é uma propriedade privada (começa com _), acessar o objeto original
				if (typeof prop === 'string' && prop.startsWith('_')) {
					// Se value é um proxy, precisamos acessar o objeto original
					const originalValue = value.__v_raw || value;
					return Reflect.get(originalValue, prop);
				}

				// Verifica se existe um descriptor para a propriedade (getter/setter)
				// Busca na cadeia de protótipos completa
				let descriptor = null;
				let currentProto = Object.getPrototypeOf(value);
				while (currentProto && !descriptor) {
					descriptor = Object.getOwnPropertyDescriptor(currentProto, prop);
					if (!descriptor) {
						currentProto = Object.getPrototypeOf(currentProto);
					}
				}
				// Também verifica no próprio objeto
				if (!descriptor) {
					descriptor = Object.getOwnPropertyDescriptor(value, prop);
				}

				if (descriptor && descriptor.get) {
					// Se há um getter, usa ele com o objeto original
					const originalValue = value.__v_raw || value;
					return descriptor.get.call(originalValue);
				} else {
					// Se não há getter, acessa diretamente
					const propVal = value[prop];
					return typeof propVal === 'function' ? propVal.bind(value) : propVal;
				}
			}
			return Reflect.get(target, prop, receiver);
		},
		set(target, prop, val, receiver) {
			if (prop === 'value') {
				target.value = val;
				return true;
			}

			const value = target.value as any;
			if (value && typeof value === 'object') {
				// Se é uma propriedade privada (começa com _), definir no objeto original
				if (typeof prop === 'string' && prop.startsWith('_')) {
					// Se value é um proxy, precisamos definir no objeto original
					const originalValue = value.__v_raw || value;
					return Reflect.set(originalValue, prop, val);
				}

				// Verifica se existe um descriptor para a propriedade (getter/setter)
				// Busca na cadeia de protótipos completa
				let descriptor = null;
				let currentProto = Object.getPrototypeOf(value);
				while (currentProto && !descriptor) {
					descriptor = Object.getOwnPropertyDescriptor(currentProto, prop);
					if (!descriptor) {
						currentProto = Object.getPrototypeOf(currentProto);
					}
				}
				// Também verifica no próprio objeto
				if (!descriptor) {
					descriptor = Object.getOwnPropertyDescriptor(value, prop);
				}

				if (descriptor && descriptor.set) {
					// Se há um setter, usa ele com o objeto original se necessário
					const originalValue = value.__v_raw || value;
					descriptor.set.call(originalValue, val);
					return true;
				} else {
					// Se não há setter, define diretamente
					value[prop] = val;
					return true;
				}
			}

			return Reflect.set(target, prop, val, receiver);
		}
	}) as unknown as Ref<T> & T;
}
